import {BrowserRouter, Routes, Route} from 'react-router'

import {Layout, ProviderLayout} from '~/react/router'
import NotFoundScreen from '~/react/screens/NotFoundScreen'

import DashboardScreen from './screens/DashboardScreen'
import RedemptionPartnersScreen from './screens/RedemptionPartnersScreen'
import PointsActivitiesScreen from './screens/PointsActivitiesScreen'
import WelcomeScreen from './screens/WelcomeScreen'

export default function Router(props) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProviderLayout {...props} />}>
          <Route
            path="points"
            element={
              <Layout
                {...props}
                supplierLayoutState="Marmalade Wallet"
                variant="secondary"
              />
            }
          >
            <Route index element={<DashboardScreen {...props} />} />
            <Route
              path="redemption_partners"
              element={<RedemptionPartnersScreen {...props} />}
            />
            <Route
              path="redemption_activities"
              element={<RedemptionPartnersScreen {...props} />}
            />
            <Route
              path="transactions"
              element={<PointsActivitiesScreen {...props} />}
            />
          </Route>
          <Route path="points">
            <Route path="welcome" element={<WelcomeScreen {...props} />} />
          </Route>
          <Route
            path="*"
            element={<Layout {...props} supplierLayoutState="Not Found" />}
          >
            <Route path="*" element={<NotFoundScreen />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
